import { render, staticRenderFns } from "./KakaoTemplateManager.vue?vue&type=template&id=10736e08&"
import script from "./KakaoTemplateManager.vue?vue&type=script&lang=ts&"
export * from "./KakaoTemplateManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports